module.exports = __webpack_public_path__ + "media/bootstrap-icons/soundwave-a059fb39.svg";